export default "__VITE_ASSET__B3J5EZuD__"